export function isExactMultipleOf24Hours(startDate, endDate) {
    // Calculate the difference in milliseconds
    const diffMilliseconds = endDate - startDate;

    // Convert milliseconds to hours
    const diffHours = diffMilliseconds / (1000 * 60 * 60);

    // Check if the difference is exactly 24 hours or a multiple of 24 hours
    return diffHours >= 24 && diffHours % 24 === 0;
}
 
export function isExactMultipleOfOneHour(startDate, endDate) {
    // Ensure the input dates are valid
    if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
        throw new Error("Invalid input: both arguments must be Date objects.");
    }

    // Calculate the difference in milliseconds
    const diffMilliseconds = endDate.getTime() - startDate.getTime();
    
    // Convert the difference from milliseconds to hours
    const diffHours = diffMilliseconds / (1000 * 60 * 60); // Convert to hours

    // Check if the difference is a whole number (integer) and a positive value
    return diffHours > 0 && Number.isInteger(diffHours);
}


export function getAdjustedDate() {
    // const now = new Date('2024-08-17 06:00:00'); // Get current date and time
    const now = new Date();
    const adjustedDate = new Date(now); // Create a copy of the current date
    // console.log('first')
    // console.log(now)

    // Check if the current time is before 6:30 AM
    const sixThirtyAM = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 6, 30, 0); // Set 6:30 AM today

    if (now < sixThirtyAM) {
        // If before 6:30 AM, subtract one day
        adjustedDate.setDate(now.getDate() - 1); 
    }

    // Return the adjusted date
    return adjustedDate;
}  

// Example usage:  
const adjustedDate = getAdjustedDate(); 
console.log(adjustedDate.toDateString()); // Will show the "adjusted" date


